import antd from 'ant-design-vue/es/locale-provider/fr_FR';
import dayjsLocale from 'dayjs/locale/fr';
import momentEnCA from 'moment/dist/locale/en-ca';
import data from '../json/fr.json';

const components = {
  antLocale: antd,
  momentName: 'eu',
  momentLocale: momentEnCA,
  dayjsName: 'fr',
  dayjsLocale
};

export default {
  ...components,
  ...data
};
